/**
 * A post-login destination taken from the URL is only followed if it is a path on
 * this app: it must start with a single "/" (no "//host", no scheme, no backslash
 * tricks). Anything else falls back to the app root.
 */
export function safeReturnTo(value: string | null | undefined): string {
    if (!value) return '/'
    if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/'
    // Control characters (header injection, \n tricks) or backslashes: refuse.
    if (value.includes('\\') || [...value].some((c) => c.charCodeAt(0) < 0x20)) return '/'
    try {
        const url = new URL(value, 'https://app.invalid')
        if (url.origin !== 'https://app.invalid') return '/'
        return `${url.pathname}${url.search}${url.hash}`
    } catch {
        return '/'
    }
}
